import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subStatus, setSubStatus] = useState<"idle" | "success" | "error">("idle");

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      setSubStatus("error");
      return;
    }
    setSubStatus("success");
    setEmail("");
    setTimeout(() => setSubStatus("idle"), 3000);
  };

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-sm" />
              </span>
              <span className="font-heading font-bold text-lg text-foreground-100">
                黑料在线
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              每日精选全网热门爆料与网红反差大瓜，国产在线黑料实时追踪，吃瓜群众必备的在线看料入口。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-fill text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-fill text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="抖音"
                rel="nofollow"
              >
                <i className="ri-tiktok-fill text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-100 text-sm mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-100 text-sm mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  rel="nofollow"
                >
                  投稿爆料
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  rel="nofollow"
                >
                  免责声明
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  rel="nofollow"
                >
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-foreground-100 text-sm mb-4">
              订阅更新
            </h4>
            <p className="text-sm text-foreground-400 mb-3 leading-relaxed">
              输入邮箱，第一时间获取独家爆料推送
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setSubStatus("idle");
                }}
                placeholder="hello@lvepkfa.cn"
                className="w-full px-3 py-2.5 rounded-lg bg-background-800 border border-background-700 text-foreground-200 text-sm placeholder:text-foreground-600 focus:outline-none focus:border-primary-500"
              />
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <button
                type="submit"
                className="w-full px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即订阅
              </button>
            </form>
            {subStatus === "success" && (
              <p className="text-xs text-accent-400 mt-2">订阅成功！感谢您的关注。</p>
            )}
            {subStatus === "error" && (
              <p className="text-xs text-primary-400 mt-2">请输入有效的邮箱地址。</p>
            )}
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 黑料在线. All rights reserved.
          </p>
          <p className="text-xs text-foreground-600">
            本站内容仅供娱乐参考，不代表任何立场
          </p>
        </div>
      </div>
    </footer>
  );
}